export default [
  {
    name: 'Земли сельхозназначения',
    key: 'forAgriculturalPurposes',
  },
  {
    name: 'Земли населенных пунктов',
    key: 'settlements',
  },
  {
    name: 'Другое',
    key: 'other',
  },
];
